const PrivacyPolicy = () => {
  return (
    <div className="flex min-h-screen w-full flex-col p-4 md:p-12">
      <h1 className="text-3xl font-bold tracking-tight">Privacy Policy</h1>
      <div className="mt-8 rounded bg-gray-900 p-8">
        <p className="mb-4">
          This privacy policy sets out how ttelements.com uses and protects any
          information that you give ttelements.com when you use this website.
        </p>
        <p className="mb-4">
          Only information that is required for the operation of the site is
          collected.
        </p>
        <p>
          Your email address is collected and used only as a unique identifier
          for your account and sending forgotten password emails. Your current
          login status is stored on your computer and validated when you play.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
